import type { PlatformStrings } from './platformStrings';

// Finnish — needs native-speaker review before go-live.
const n = (count: number, one: string, many: string) => (count === 1 ? one : many);

export const platformFi: PlatformStrings = {
  'err.generic': (detail: string) => `Jokin meni vikaan: ${detail}`,
  'err.not_authorized': 'Sinulla ei ole oikeutta tähän nykyisessä roolissasi.',
  'err.unknown': 'Jokin meni vikaan. Yritä uudelleen; jos ongelma jatkuu, tarkista alustan loki.',
  'err.ops_unreachable': 'Tilipalveluun ei saatu yhteyttä. Tarkista yhteys ja yritä uudelleen.',
  'err.bad_request': 'Tietoja puuttuu. Täytä kaikki kentät ja yritä uudelleen.',
  'err.ack_missing': 'Kirjaa ensin rehtorin vahvistus.',
  'err.ack_required': 'Kirjaa, kuka vahvisti ja minä päivänä (ei tulevaisuudessa).',
  'err.admins_without_mfa': 'Jokaisen alustan ylläpitäjän on otettava todennussovellus käyttöön ennen kuin kaksivaiheinen tunnistautuminen voidaan vaatia.',
  'err.already_invited': 'Tälle sähköpostille on jo odottava kutsu.',
  'err.already_on_staff': 'Tämä sähköposti on jo henkilökunnassa.',
  'err.already_requested': 'Tämän henkilön poistopyyntö odottaa jo hyväksyntää.',
  'err.bad_assignment': 'Jokin luokista tai vuosiluokista ei kuulu tähän kouluun. Lataa sivu uudelleen ja yritä.',
  'err.bad_email': 'Anna kelvollinen sähköpostiosoite.',
  'err.bad_expiry': 'Valitse voimassaolo 1–90 päivää.',
  'err.bad_language': 'Valitse kieli.',
  'err.bad_paperwork': 'Valitse sopimuksen tila.',
  'err.bad_role': 'Valitse rooli listasta.',
  'err.bad_section': 'Rinnakkaisluokan tunnus on 1–8 merkkiä.',
  'err.bad_size': 'Oppilasmäärä on luku 1–200.',
  'err.bad_stage': 'Vuosiluokka ei ole koulun listassa. Lisää se kohdassa Luokat → Nimeämistapa.',
  'err.bad_step': 'Tuntematon tarkistuslistan vaihe.',
  'err.bad_test_login': 'Kirjautumista ei voitu liittää testitiliin. Yritä uudelleen.',
  'err.bad_type': 'Valitse Hiekkalaatikko tai Asiakas.',
  'err.cannot_suspend': 'Vain käyttöönotossa tai käytössä oleva koulu voidaan keskeyttää.',
  'err.cells_required': 'Valitse ruudukosta vähintään yksi luokka.',
  'err.class_exists': 'Luokka on jo olemassa.',
  'err.class_has_sessions': 'Luokalla on kyselyhistoriaa, joten sen voi vain arkistoida.',
  'err.confirm_mismatch': 'Kirjoittamasi ei täsmää. Kirjoita se täsmälleen vahvistaaksesi.',
  'err.confirmation_required': 'Kirjaa, kenen kanssa koulussa vahvistit asian.',
  'err.date_in_future': 'Päivämäärä ei voi olla tulevaisuudessa.',
  'err.date_in_past': 'Uudelleenaktivoinnin päivän on oltava tulevaisuudessa.',
  'err.deactivate_first': 'Poista henkilö käytöstä ennen hänen tietojensa poistamista.',
  'err.duplicate_role': 'Rooli on listassa kahdesti.',
  'err.duplicate_section': 'Rinnakkaisluokka on listassa kahdesti.',
  'err.hold_not_over': '30 päivän odotusaika ei ole vielä päättynyt.',
  'err.instruction_required': 'Kirjaa muistiinpanoon koulun kirjallinen ohje (kuka lähetti ja milloin).',
  'err.invites_customer_only': 'Hiekkalaatikkokoulut käyttävät testitilejä, eivät kutsuja.',
  'err.last_school_admin': 'Tämä on koulun viimeinen koulun ylläpitäjä. Lisää ensin toinen.',
  'err.mfa_session_needed': 'Kirjaudu ensin todennuskoodilla ja yritä sitten uudelleen.',
  'err.name_required': 'Anna nimi.',
  'err.no_active_year': 'Koululla ei ole aktiivista lukuvuotta.',
  'err.no_session': 'Kirjautumisestasi puuttuu istuntotunniste. Kirjaudu ulos ja uudelleen sisään.',
  'err.not_a_head': 'Vain aktiivinen apulaisrehtori voi tulla ensisijaiseksi rehtoriksi.',
  'err.not_a_teacher': 'Anna henkilölle ensin Opettaja-rooli.',
  'err.not_admin_role': 'Kaksivaiheinen tunnistautuminen nollataan vain ylläpitäjärooleille.',
  'err.not_in_school': 'Henkilö ei ole tämän koulun henkilökuntaa.',
  'err.not_platform_admin': 'Henkilö ei ole alustan ylläpitäjä.',
  'err.not_sandbox': 'Vain hiekkalaatikkokoulusta voi tulla asiakaskoulu.',
  'err.not_suspended': 'Koulua ei ole keskeytetty.',
  'err.not_test_account': 'Vain testitilien salasanoja voi nollata. Oikealla henkilökunnalla ei ole salasanaa Swipessä.',
  'err.not_yourself': 'Toisen alustan ylläpitäjän on nollattava oma kaksivaiheinen tunnistautumisesi.',
  'err.note_required': 'Kerro syy lyhyesti.',
  'err.own_request': 'Et voi päättää omasta pyynnöstäsi etkä itseäsi koskevasta pyynnöstä.',
  'err.paperwork_signed_needs': 'Allekirjoitetulle sopimukselle tarvitaan päivämäärä ja allekirjoittajan nimi.',
  'err.person_not_active': 'Henkilö ei ole aktiivinen. Aktivoi hänet ensin.',
  'err.person_not_deactivated': 'Henkilöä ei ole poistettu käytöstä.',
  'err.primary_head': 'Tämä on ensisijainen rehtori. Siirrä ensisijaisuus ensin apulaisrehtorille.',
  'err.primary_head_decides': 'Koululla on ensisijainen rehtori, joka päättää tästä pyynnöstä.',
  'err.reason_required': 'Valitse syy (ja täytä tarvittavat tiedot).',
  'err.request_expired': 'Pyyntö on vanhentunut.',
  'err.request_gone': 'Pyynnöstä on jo päätetty tai se on peruttu.',
  'err.role_exists': 'Henkilöllä on jo tämä rooli tai pyyntö siitä.',
  'err.role_required': 'Valitse vähintään yksi rooli.',
  'err.school_name_taken': 'Samanniminen koulu on jo olemassa.',
  'err.school_not_active': 'Koulu on keskeytetty tai lähtenyt Swipestä.',
  'err.school_not_ready': 'Kyselyt avautuvat, kun koulun käyttöönotto on valmis.',
  'err.school_offboarded': 'Koulu on lähtenyt Swipestä.',
  'err.second_admin_needed': 'Toisen alustan ylläpitäjän on päätettävä tästä pyynnöstä.',
  'err.sections_required': 'Jätä vähintään yksi rinnakkaisluokka.',
  'err.stage_in_use': 'Vuosiluokkaa, jolla on luokkia, ei voi poistaa. Arkistoi luokat ensin.',
  'err.support_required': 'Siirry ensin tämän koulun tukitilaan.',
  'err.test_accounts_remain': 'Poista ensin koulun testitilit.',
  'err.test_accounts_sandbox_only': 'Testitilejä on vain hiekkalaatikkokouluissa.',
  'err.test_expired': 'Testitili on vanhentunut. Jatka sitä ensin.',
  'err.tier_required': 'Asiakaskoululle tarvitaan taso.',
  'err.too_long': 'Pidä jokainen viesti alle 600 merkissä.',
  'err.two_admins_needed': 'Zenceralla on oltava vähintään kaksi alustan ylläpitäjää ennen kuin kaksivaiheinen tunnistautuminen vaaditaan.',
  'err.unknown_assignment': 'Tehtävä on jo päättynyt.',
  'err.unknown_class': 'Tuntematon luokka. Lataa sivu uudelleen ja yritä.',
  'err.unknown_invite': 'Kutsu on jo käytetty tai peruttu.',
  'err.unknown_municipality': 'Valitse kunta.',
  'err.unknown_person': 'Henkilön tiedot on jo poistettu.',
  'err.unknown_role': 'Rooli on jo poistettu.',
  'err.unknown_school': 'Tuntematon koulu.',

  'pa.navApprovals': 'Hyväksynnät',
  'pa.navApprovalsN': (c: number) => `Hyväksynnät (${c})`,
  'pa.navLog': 'Alustan loki',
  'pa.navArchive': 'Arkisto',
  'pa.navSettings': 'Asetukset',
  'pa.working': 'Käsitellään…',
  'pa.save': 'Tallenna',
  'pa.saved': 'Tallennettu.',
  'pa.close': 'Sulje',
  'pa.keep': 'Säilytä',
  'pa.back': '← Takaisin',
  'pa.next': 'Seuraava',
  'pa.add': 'Lisää',
  'pa.edit': 'Muokkaa',
  'pa.remove': 'Poista',
  'pa.withdraw': 'Peru pyyntö',
  'pa.view': 'Näytä',
  'pa.hide': 'Piilota',
  'pa.download': 'Lataa',
  'pa.copy': 'Kopioi',
  'pa.copied': 'Kopioitu',
  'pa.copyFailed': 'Kopiointi ei onnistunut. Valitse teksti ja kopioi se itse.',
  'pa.copyCode': 'Kopioi koulun koodi',
  'pa.copyUsername': 'Kopioi käyttäjätunnus',
  'pa.copyPassword': 'Kopioi salasana',
  'pa.optional': 'Valinnainen.',
  'pa.note': 'Muistiinpano',
  'pa.noteOptional': 'Muistiinpano (valinnainen)',
  'pa.reason': 'Syy',
  'pa.status': 'Tila',
  'pa.done': 'Valmis',
  'pa.notDone': 'Ei tehty',
  'pa.yes': 'Kyllä',
  'pa.missing': 'Puuttuu',
  'pa.never': 'ei koskaan',
  'pa.nothing': 'ei mitään',
  'pa.you': 'sinä',
  'pa.on': 'Päällä',
  'pa.off': 'Pois',
  'pa.actions': 'Toiminnot',
  'pa.loadMore': 'Lataa lisää',
  'pa.name': 'Nimi',
  'pa.email': 'Sähköposti',
  'pa.language': 'Kieli',
  'pa.schoolDefault': 'Koulun oletus',
  'pa.lang_fi': 'suomi',
  'pa.lang_sv': 'ruotsi',
  'pa.lang_en': 'englanti',
  'pa.tier_a': 'Taso A',
  'pa.tier_b': 'Taso B',
  'pa.tier_aDesc': 'Jaettu tietokanta. Koulun tiedot ovat Swipen yhteisessä tietokannassa, ja käyttöoikeussäännöt pitävät ne erillään muista kouluista. Perushinta.',
  'pa.tier_bDesc': 'Oma tietokanta. Koululle perustetaan oma, kaikista muista kouluista erillinen tietokanta, jota hallitaan silti tältä alustalta. Lisähinta.',
  'pa.tierHint': 'Taso B pyytää Zenceraa perustamaan oman tietokannan. Koulu pysyy käyttöönottotilassa, kunnes Zencera vahvistaa tietokannan valmiiksi.',
  'pa.comingLater': 'Tulossa myöhemmin',
  'pa.tier_bSoon': 'Ei vielä käytettävissä. Taso B avautuu, kun Zencera voi perustaa ja ylläpitää omia tietokantoja tältä alustalta.',
  'err.tier_b_unavailable': 'Taso B (oma tietokanta) ei ole vielä käytettävissä. Valitse taso A.',
  'pa.tier_aShort': 'Taso A · jaettu tietokanta',
  'pa.tier_bShort': 'Taso B · oma tietokanta',
  'pa.school': 'Koulu',
  'pa.person': 'Henkilö',

  'pa.statLive': 'Käytössä olevat koulut',
  'pa.statLiveSub': (setting: number, suspended: number) => `${setting} käyttöönotossa · ${suspended} keskeytetty`,
  'pa.statApprovals': 'Odottavat hyväksynnät',
  'pa.statApprovalsSub': 'Zenceran päätettävänä',
  'pa.statTests': 'Testitilit',
  'pa.statTestsSub': (expiring: number) => `${expiring} vanhenee 7 päivän sisällä`,
  'pa.addSchoolDesc': 'Hiekkalaatikko tai asiakas, ensimmäisine henkilöineen.',
  'pa.approvalsDesc': 'Pyynnöt, joista vain Zencera voi päättää.',
  'pa.logDesc': 'Kaikki koulujen väliset toimet, vain lisättävä loki.',
  'pa.attnSetup': (s: string, d: number, total: number) => `${s}: käyttöönotosta ${d}/${total} pakollista kohtaa valmiina.`,
  'pa.attnSeeChecklist': 'Tarkistuslista',
  'pa.attnOffboardReady': (s: string) => `${s}: 30 päivän odotusaika on ohi; valmis poistettavaksi.`,
  'pa.attnOffboardAck': (s: string) => `${s}: odotusaika ohi, mutta rehtorin vahvistusta ei ole kirjattu.`,
  'pa.attnNoSchoolAdmin': (s: string) => `${s}: ei aktiivista koulun ylläpitäjää.`,
  'pa.attnOneAdmin': 'Zenceralla on vain yksi alustan ylläpitäjä. Lisää toinen (README §6).',
  'pa.attnApprovals': (c: number) => `${c} ${n(c, 'pyyntö odottaa', 'pyyntöä odottaa')} Zenceraa.`,
  'pa.attnReview': 'Käsittele',
  'pa.attnTestsExpired': (c: number) => `${c} ${n(c, 'vanhentunut testitili odottaa', 'vanhentunutta testitiliä odottaa')} poistoa.`,

  'pa.searchSchools': 'Hae nimellä tai koodilla',
  'pa.filterType': 'Suodata tyypin mukaan',
  'pa.filterState': 'Suodata tilan mukaan',
  'pa.allTypes': 'Kaikki tyypit',
  'pa.allStates': 'Kaikki tilat',
  'pa.stateNotOffboarded': 'Kaikki paitsi poistetut',
  'pa.noMatch': 'Mikään koulu ei vastaa suodattimia.',
  'pa.municipality': 'Kunta',
  'pa.staff': 'Henkilökunta',
  'pa.nTest': (c: number) => `${c} testi`,
  'pa.lastActivity': 'Viimeisin toiminta',
  'pa.setupProgress': (d: number, total: number) => `Käyttöönotto: ${d}/${total} pakollista`,
  'pa.agreementShort': 'Sopimus',
  'pa.dpaShort': 'Käsittelysopimus',
  'pa.paperworkPill': (doc: string, status: string) => `${doc}: ${status}`,
  'pa.pwNotStarted': 'Ei aloitettu',
  'pa.pwSent': 'Lähetetty',
  'pa.pwSigned': 'Allekirjoitettu',

  'pa.wizSteps': 'Vaiheet',
  'pa.wizStepOf': (i: number, total: number, name: string) => `Vaihe ${i}/${total}: ${name}`,
  'pa.wizType': 'Tyyppi',
  'pa.wizDetails': 'Tiedot',
  'pa.wizPaperwork': 'Sopimus',
  'pa.wizPeople': 'Ensimmäiset henkilöt',
  'pa.wizReview': 'Tarkistus',
  'pa.schoolType': 'Koulun tyyppi',
  'pa.sandboxDesc': 'Pilottikoulu. Koulu on rekisterinpitäjä ja allekirjoittaa hiekkalaatikkosopimuksen. Henkilökunta käyttää Zenceran tekemiä testitilejä; sähköpostia ei lähetetä.',
  'pa.customerDesc': 'Maksava koulu täydellä henkilötietojen käsittelysopimuksella. Henkilökunta liittyy sähköpostikutsulla ja kirjautuu kertakoodilla.',
  'pa.typeHint': 'Hiekkalaatikkokoulusta voi myöhemmin tulla asiakaskoulu, ei toisin päin.',
  'pa.chooseMunicipality': 'Valitse kunta…',
  'pa.codeFromMunicipality': 'Koulun koodi muodostetaan siitä (FI-HEL-7KQ2), eikä se muutu koskaan.',
  'pa.officialNumber': 'Oppilaitosnumero',
  'pa.stages': 'Vuosiluokat',
  'pa.stagesHint': 'Näistä tulee luokkaruudukon rivit. Voit muuttaa niitä myöhemmin.',
  'pa.levelsBasic': 'Perusopetus',
  'pa.levelsUpper': 'Lukio',
  'pa.levelsVocational': 'Ammatillinen',
  'pa.defaultLanguage': 'Oletuskieli',
  'pa.tier': 'Taso',
  'pa.wizStagesNeeded': 'Valitse vähintään yksi vuosiluokka.',
  'pa.agreement': 'Hiekkalaatikkosopimus',
  'pa.dpa': 'Henkilötietojen käsittelysopimus',
  'pa.paperworkSandboxHint': 'Vain Zencera asettaa tämän. Koulu näkee sen tarkistuslistallaan; kyselyt avautuvat, kun se on allekirjoitettu.',
  'pa.paperworkCustomerHint': 'Vain Zencera asettaa tämän. Kyselyt avautuvat, kun sopimus on allekirjoitettu ja käyttöönotto valmis.',
  'pa.signedOn': 'Allekirjoituspäivä',
  'pa.signatory': 'Allekirjoittaja (koulun allekirjoittaja)',
  'pa.signedBy': (who: string, date: string) => `Allekirjoittanut ${who}, ${date}`,
  'pa.peopleSandboxNote': 'Näille rooleille tehdään nyt testitilit; käyttäjätunnus ja salasana näytetään kerran. Käytä keksittyjä nimiä — koulu pitää itse listaa siitä, kenellä on mikäkin tili.',
  'pa.peopleCustomerNote': 'Kutsut jonotetaan nyt ja lähetetään, kun sähköpostipalvelu on käytössä. Jokainen kirjautuu kertakoodilla; salasanaa ei luoda.',
  'pa.headName': 'Rehtori (ensisijainen)',
  'pa.headNameTest': 'Rehtori (ensisijainen) — keksitty nimi',
  'pa.fictionalExample': 'esim. Helmi Koivu (TESTI)',
  'pa.workEmail': 'Työsähköposti',
  'pa.sameAdmin': 'Rehtori on myös koulun ylläpitäjä',
  'pa.adminName': 'Koulun ylläpitäjä',
  'pa.adminNameTest': 'Koulun ylläpitäjä — keksitty nimi',
  'pa.wizHeadNeeded': 'Anna rehtorin nimi.',
  'pa.wizAdminNeeded': 'Anna koulun ylläpitäjän nimi.',
  'pa.firstPeople': 'Ensimmäiset henkilöt',
  'pa.reviewSame': (h: string) => `${h} — ensisijainen rehtori ja koulun ylläpitäjä`,
  'pa.reviewTwo': (h: string, a: string) => `${h} — ensisijainen rehtori; ${a} — koulun ylläpitäjä`,
  'pa.afterCreate': 'Kun luot koulun',
  'pa.afterCreateSandbox': 'Siirryt koulun tukitilaan (kirjataan) ja testitilit tehdään.',
  'pa.afterCreateCustomer': 'Siirryt koulun tukitilaan (kirjataan) ja kutsut jonotetaan.',
  'pa.createSchool': 'Luo koulu',
  'pa.codeHint': 'Henkilökunta kirjoittaa tämän koodin kirjautumissivulle. Jaa se koululle.',
  'pa.credsTitle': 'Testitilin kirjautumistiedot',
  'pa.credsOnce': 'Näytetään vain nyt. Toimita salasana eri kanavaa pitkin kuin käyttäjätunnus — henkilökohtaisesti, puhelimitse tai toisessa viestissä — ei koskaan yhdessä. Se toimii vain kerran: ensimmäisellä kirjautumisella henkilön on valittava oma salasana ennen kuin mikään avautuu.',
  'pa.username': 'Käyttäjätunnus',
  'pa.password': 'Salasana',
  'pa.invitesQueuedNote': 'Kutsut ovat jonossa: sähköpostipalvelua ei ole vielä käytössä, joten mitään ei lähetetä. Ne lähtevät automaattisesti, kun se on.',
  'pa.peopleFailed': 'Koulu luotiin, mutta näitä henkilöitä ei lisätty. Lisää heidät koulun Henkilökunta-välilehdeltä:',
  'pa.openSchool': 'Avaa koulu',

  'pa.schoolSummary': 'Koulun yhteenveto',
  'pa.schoolSections': 'Koulun osiot',
  'pa.inSupportPill': 'Tukitila päällä',
  'pa.inSupportHint': 'Olet tämän koulun tukitilassa. Kaikki toimesi kirjataan ja näkyvät koululle.',
  'pa.enterSupport': 'Siirry tukitilaan',
  'pa.enterSupportGo': 'Siirry tukitilaan',
  'pa.enterSupportIntro': 'Tukitilassa voit muuttaa koulun henkilökuntaa, luokkia ja asetuksia kahden tunnin ajan. Banneri näkyy joka näkymässä, jokainen toimi näkyy koulun omassa toimintalokissa, ja tulokset pysyvät piilossa.',
  'pa.supportEntered': (s: string) => `Tukitila päällä: ${s}.`,
  'pa.supportLeft': 'Tukitila päättyi.',
  'pa.supportRegion': 'Tukitila',
  'pa.supportBanner': 'Tukitila — Zencera. Toimet kirjataan ja näkyvät koululle.',
  'pa.supportEnds': (m: number) => `päättyy ${m} min kuluttua`,
  'pa.supportLeave': 'Poistu tukitilasta',
  'pa.supportNeeded': (what: string) => `Jotta voit ${what}, siirry tämän koulun tukitilaan.`,
  'pa.sr_school_asked': 'Koulu pyysi apua',
  'pa.sr_setup_stuck': 'Käyttöönotto on jumissa',
  'pa.sr_account_recovery': 'Tilin palautus',
  'pa.sr_approval_no_primary_head': 'Hyväksyntä ilman ensisijaista rehtoria',
  'pa.sr_test_accounts': 'Testitilit',
  'pa.sr_other': 'Muu',
  'pa.tabStaff': (c: number) => `Henkilökunta (${c})`,
  'pa.tabStaffPlain': 'Henkilökunta',
  'pa.tabClasses': (c: number) => `Luokat (${c})`,
  'pa.tabSettings': 'Asetukset',
  'pa.tabActivity': 'Toiminta',
  'pa.checklist': 'Käyttöönoton tarkistuslista',
  'pa.gateSandbox': 'Hiekkalaatikko: vain turvaverkkoviesti ja allekirjoitettu sopimus estävät kyselyt, koska oikeat oppilaat näkevät kyselynäkymän. Muut ovat varoituksia.',
  'pa.gateCustomer': 'Asiakas: jokaisen pakollisen kohdan on oltava valmis ennen kuin kyselyt avautuvat.',
  'pa.gateDone': 'Käyttöönotto on riittävän valmis kyselyille. Varoitukset näkyvät edelleen henkilökunnalle.',
  'pa.requiredTodo': 'Pakollinen',
  'pa.warningTodo': 'Varoitus',
  'pa.ckSafetyNet': 'Turvaverkkoviesti (suomi, ruotsi, englanti)',
  'pa.ckPaperworkSandbox': 'Hiekkalaatikkosopimus allekirjoitettu',
  'pa.ckPaperworkCustomer': 'Käsittelysopimus allekirjoitettu',
  'pa.ckProfile': 'Koulun tiedot, vuosiluokat ja rinnakkaisluokat vahvistettu',
  'pa.ckClasses': 'Luokat luotu',
  'pa.ckStaffSandbox': 'Testitilit luotu',
  'pa.ckStaffCustomer': 'Henkilökunta kutsuttu',
  'pa.ckTeachers': 'Jokainen opettaja liitetty luokkaan',
  'pa.ckNotice': 'Tiedote huoltajille ja oppilaille lähetetty',
  'pa.ckDpo': 'Tietosuojavastaavan hyväksyntä',
  'pa.ckDedicated': 'Zencera on vahvistanut oman tietokannan (taso B)',
  'pa.confirmDedicated': 'Vahvista valmiiksi',
  'pa.dedicatedTitle': 'Vahvista oma tietokanta',
  'pa.dedicatedIntro': 'Vahvista vasta, kun koulun oma tietokanta on perustettu ja tarkistettu. Vahvistus kirjataan koulun tapahtumiin, ja koulun ylläpitäjät ja ensisijainen rehtori saavat tiedon. Koulu otetaan käyttöön, kun sen muut pakolliset vaiheet ovat valmiit.',
  'pa.dedicatedRefLabel': 'Oman tietokannan tunniste',
  'pa.dedicatedRefHint': 'Esimerkiksi Supabase-projektin tunniste. Näkyy koulun lokissa; ei koskaan salasanaa tai avainta.',
  'pa.dedicatedRef': (ref: string) => `Valmis · ${ref}`,
  'pa.dedicatedConfirmed': 'Oma tietokanta vahvistettu.',
  'err.not_requested': 'Tällä koululla ei ole vahvistusta odottavaa omaa tietokantaa.',
  'err.reference_required': 'Kirjoita oman tietokannan tunniste.',
  'err.reference_too_long': 'Tunnisteen enimmäispituus on 200 merkkiä.',
  'pa.changePaperwork': 'Muuta',
  'pa.goSettings': 'Asetukset',
  'pa.goClasses': 'Luokat',
  'pa.goStaff': 'Henkilökunta',
  'pa.markDone': 'Merkitse valmiiksi',
  'pa.reopen': 'Avaa uudelleen',
  'pa.markDoneIntro': 'Merkitse vaihe valmiiksi koulun puolesta. Se kirjataan nimelläsi ja kellonajalla.',
  'pa.reopenIntro': 'Avaa vaihe uudelleen. Jos se on pakollinen, kyselyt pysyvät auki, kunnes keskeytät koulun.',
  'pa.paperworkOnlyZencera': 'Vain Zencera asettaa sopimuksen tilan. Se kopioidaan kriittisten tietueiden arkistoon.',
  'pa.nowLive': 'Tallennettu. Kaikki pakolliset kohdat ovat valmiita: koulu on nyt käytössä.',
  'pa.about': 'Tietoa koulusta',
  'pa.contractRef': 'Sopimusviite',
  'pa.created': 'Luotu',
  'pa.classes': 'Luokat',
  'pa.nNoTeacher': (c: number) => `${c} ilman opettajaa`,
  'pa.primaryHead': 'Ensisijainen rehtori',
  'pa.schoolAdmins': 'Koulun ylläpitäjät',
  'pa.supportHistory': 'Viimeisimmät tukitilat',

  'pa.lifecycle': 'Koulun elinkaari',
  'pa.lifecycleHint': 'Alustatason toimia. Ne eivät vaadi tukitilaa, ja ne kirjataan alustan lokiin ja arkistoon.',
  'pa.suspend': 'Keskeytä koulu',
  'pa.suspendTitle': (s: string) => `Keskeytetäänkö ${s}?`,
  'pa.suspendIntro': 'Henkilökunta kirjataan ulos eikä voi kirjautua. Avoimet kyselyt suljetaan; oppilaiden linkit kertovat, että kyselyt ovat tauolla, ja turvaverkkoviesti näkyy. Mitään ei poisteta, ja voit jatkaa milloin tahansa.',
  'pa.sus_contract_lapse': 'Sopimus päättynyt',
  'pa.sus_data_protection': 'Tietosuojahuoli',
  'pa.sus_sandbox_ended': 'Hiekkalaatikko päättyi, päätös kesken',
  'pa.sus_other': 'Muu',
  'pa.suspendMessage': 'Viesti henkilökunnalle (valinnainen)',
  'pa.suspendMessageHint': 'Näytetään koulun henkilökunnalle kirjautumissivulla.',
  'pa.suspendedDone': 'Koulu keskeytetty.',
  'pa.suspendedSince': (d: string) => `Keskeytetty ${d} alkaen`,
  'pa.resume': 'Jatka koulua',
  'pa.resumeTitle': (s: string) => `Jatketaanko ${s}?`,
  'pa.resumeIntro': 'Henkilökunta voi taas kirjautua, ja koulu palaa aiempaan tilaansa.',
  'pa.resumedDone': 'Koulu jatkuu.',
  'pa.convert': 'Muuta asiakaskouluksi',
  'pa.convertTitle': 'Muuta Hiekkalaatikko → Asiakas',
  'pa.convertIntro': 'Sen jälkeen sovelletaan asiakkaan tarkistuslistaa: uudet pakolliset kohdat avaavat käyttöönoton ja estävät kyselyt, kunnes ne ovat valmiita. Muutosta ei voi perua.',
  'pa.convertTestsFirst': (c: number) => `Poista ensin koulun ${c} ${n(c, 'testitili', 'testitiliä')} (Henkilökunta-välilehti).`,
  'pa.convertedDone': 'Koulu on nyt asiakaskoulu.',
  'pa.offStepHold': (d: string) => `30 päivän odotusaika päättyy ${d}. Odotusaikana koulu voi viedä tietonsa.`,
  'pa.offStepAck': 'Ensisijainen rehtori vahvistaa, että anonyymit koosteet säilytetään.',
  'pa.offStepAckDone': (who: string, d: string) => `Vahvistanut ${who}, ${d}.`,
  'pa.offStepConfirm': 'Kirjoita koulun koodi poistaaksesi koulun.',
  'pa.recordAck': 'Kirjaa vahvistus',
  'pa.ackIntro': 'Kirjaa ensisijaisen rehtorin kirjallinen vahvistus tälle tekstille:',
  'pa.ackText': 'Zencera säilyttää tietosuojarajan ylittävät anonyymit koosteet poistamisen jälkeen, kuten sopimuksessamme todetaan.',
  'pa.ackBy': 'Vahvistaja',
  'pa.ackOn': 'Vahvistuspäivä',
  'pa.offboard': 'Poista koulu',
  'pa.offboardTitle': (s: string) => `Poistetaanko ${s}?`,
  'pa.offboardIntro': 'Tätä ei voi perua.',
  'pa.offboardErase': (c: number) => `${c} henkilökunnan ja testitilin henkilötiedot poistetaan.`,
  'pa.offboardKeep': 'Anonyymit koosteet säilytetään, kuten vahvistettiin.',
  'pa.offboardReport': 'Allekirjoittajan GDPR-yhteenveto tallennetaan arkistoon.',
  'pa.typeCode': (code: string) => `Kirjoita ${code} vahvistaaksesi`,
  'pa.offboardedDone': 'Koulu poistettu. GDPR-yhteenveto on arkistossa.',
  'pa.offboardedOn': (d: string) => `Poistettu ${d}. Henkilökunnan tiedot poistettiin; anonyymit koosteet säilytetään.`,
  'pa.seeReport': 'Näytä GDPR-yhteenveto',

  'pa.people': 'Henkilöt',
  'pa.noPeople': 'Kenelläkään ei ole vielä roolia tässä koulussa.',
  'pa.addTestAccount': '+ Lisää testitili',
  'pa.inviteStaff': '+ Kutsu henkilö',
  'pa.whatTestAccounts': 'lisätä tai muuttaa testitilejä',
  'pa.whatInvite': 'kutsua tai muuttaa henkilökuntaa',
  'pa.whatPerson': 'muuttaa tämän henkilön rooleja, luokkia tai tiliä',
  'pa.whatClasses': 'lisätä luokkia tai liittää opettajia',
  'pa.whatSettings': 'muuttaa koulun tietoja, käytäntöjä tai turvaverkkoviestiä',
  'pa.noClasses': 'Ei luokkia',
  'pa.gradeLeadOf': (g: string) => `Vuosiluokka ${g}, vastuuopettaja`,
  'pa.expires': (d: string) => `Vanhenee ${d}`,
  'pa.lastSignIn': (d: string) => `Viimeksi kirjautunut: ${d}`,
  'pa.invites': 'Odottavat kutsut',
  'pa.inviteQueued': 'Jonossa',
  'pa.inviteSent': 'Lähetetty',
  'pa.cancelInvite': 'Peru kutsu',
  'pa.cancelInviteFor': (who: string) => `Peru kutsu: ${who}`,
  'pa.cancelInviteIntro': 'Kutsua ei voi käyttää tämän jälkeen. Voit kutsua henkilön myöhemmin uudelleen.',
  'pa.inviteCancelled': 'Kutsu peruttu.',
  'pa.testIntro': 'Hiekkalaatikon testitili: keksitty nimi, luotu käyttäjätunnus (osoite, johon ei voi lähettää postia) ja salasana, TESTI-merkintä kaikkialla. Tili poistetaan automaattisesti, kun se vanhenee.',
  'pa.inviteIntro': 'Henkilö saa liittymiskutsun sähköpostitse (kun sähköpostipalvelu on käytössä) ja kirjautuu kertakoodilla.',
  'pa.fictionalName': 'Keksitty näyttönimi',
  'pa.fullName': 'Koko nimi',
  'pa.roles': 'Roolit',
  'pa.role': 'Rooli',
  'pa.makePrimary': 'Ensisijainen rehtori (jos koululla ei ole)',
  'pa.counsellorScope': 'Näkee',
  'pa.wholeSchool': 'Koko koulun',
  'pa.chosenGrades': 'Valitut vuosiluokat',
  'pa.gradeN': (g: string) => `Vuosiluokka ${g}`,
  'pa.noClassesYet': 'Ei vielä luokkia — lisää ne Luokat-välilehdellä ja liitä sitten.',
  'pa.classesOptional': 'Luokat (valinnainen)',
  'pa.kindFor': (c: string) => `Tehtävän tyyppi luokassa ${c}`,
  'pa.kind': 'Tyyppi',
  'pa.kind_homeroom': 'Ryhmänohjaaja',
  'pa.kind_subject': 'Aineenopettaja',
  'pa.kind_grade_lead': 'Vuosiluokan vastuuopettaja',
  'pa.kindHint_homeroom': 'Avaa kyselyt ja näkee luokan tulokset. Yleensä yksi luokkaa kohden.',
  'pa.kindHint_subject': 'Avaa kyselyt ja näkee luokan tulokset. Luokassa voi olla useita.',
  'pa.kindHint_grade_lead': 'Näkee vuosiluokan tulokset; avaa kyselyjä vain luokissa, joihin on myös liitetty.',
  'pa.expiresIn': 'Voimassa',
  'pa.nDays': (d: number) => `${d} päivää`,
  'pa.inviteLanguage': 'Kutsun kieli',
  'pa.wideningNote': 'Rehtori, kuraattori ja koulun ylläpitäjä laajentavat sitä, mitä henkilö näkee: ne odottavat ensisijaisen rehtorin hyväksyntää (tai Zenceran, jos koululla ei ole ensisijaista rehtoria).',
  'pa.createTest': 'Luo testitili',
  'pa.queueInvite': 'Jonota kutsu',
  'pa.addAnother': 'Lisää toinen',
  'pa.testCreated': (who: string) => `Testitili luotu: ${who}.`,
  'pa.inviteQueuedDone': (who: string) => `Kutsu jonossa: ${who}.`,
  'pa.schoolCodeForLogin': (code: string) => `Kirjautumissivulla annetaan ensin koulun koodi ${code}.`,
  'pa.roleName_school_admin': 'Koulun ylläpitäjä',
  'pa.roleName_head_of_school': 'Rehtori',
  'pa.roleName_counsellor': 'Kuraattori',
  'pa.roleName_teacher': 'Opettaja',
  'pa.rolePrimaryHead': 'Rehtori (ensisijainen)',
  'pa.roleDeputyHead': 'Rehtori (apulais-)',
  'pa.rolePending': (r: string) => `${r} — odottaa hyväksyntää`,
  'pa.statusActive': 'Aktiivinen',
  'pa.statusActiveTest': 'Aktiivinen (TESTI)',
  'pa.statusDeactivated': 'Poistettu käytöstä',
  'pa.statusExpired': 'Vanhentunut',

  'pa.personGone': 'Henkilö ei ole enää tämän koulun henkilökuntaa (tiedot on ehkä poistettu).',
  'pa.backToStaff': '← Takaisin henkilökuntaan',
  'pa.details': 'Tiedot',
  'pa.expiry': 'Vanhenee',
  'pa.lastSignInLabel': 'Viimeisin kirjautuminen',
  'pa.authenticators': 'Todennussovellukset',
  'pa.otherSchools': 'Muut koulut',
  'pa.otherSchoolsN': (c: number) => `Myös ${c} ${n(c, 'muun koulun', 'muun koulun')} henkilökuntaa`,
  'pa.reactivatesOn': (d: string) => `aktivoituu ${d}`,
  'pa.account': 'Kirjautuminen ja tili',
  'pa.signOutEverywhere': 'Kirjaa ulos kaikkialta',
  'pa.signOutIntro': (who: string) => `${who} kirjataan ulos kaikilta laitteilta minuutin kuluessa.`,
  'pa.resetPassword': 'Nollaa salasana',
  'pa.resetPasswordIntro': 'Uusi salasana luodaan ja näytetään kerran. Vanha lakkaa toimimasta ja henkilö kirjataan ulos. Uudella salasanalla ei avaudu mitään ennen kuin henkilö valitsee oman salasanan.',
  'pa.passwordReset': 'Uusi salasana luotu.',
  'pa.extendExpiry': 'Jatka voimassaoloa',
  'pa.extendIntro': 'Asettaa uuden vanhenemispäivän tästä päivästä laskien (enintään 90 päivää).',
  'pa.resetMfa': 'Nollaa kaksivaiheinen tunnistautuminen',
  'pa.resetMfaFor': (who: string) => `Nollaa kaksivaiheinen tunnistautuminen: ${who}`,
  'pa.resetMfaIntro': 'Poistaa henkilön todennussovellukset, jotta hän voi ottaa uuden käyttöön. Varmista henkilöllisyys ensin sovelluksen ulkopuolella (soitto tunnettuun numeroon tai kasvokkain).',
  'pa.resetMfaAdminIntro': 'Poistaa tämän alustan ylläpitäjän todennussovellukset. Varmista henkilöllisyys ensin sovelluksen ulkopuolella.',
  'pa.confirmedHow': 'Miten varmistit henkilöllisyyden',
  'pa.deactivate': 'Poista käytöstä',
  'pa.deactivateTitle': (who: string) => `Poistetaanko ${who} käytöstä?`,
  'pa.deactivateIntro': (who: string, c: number) =>
    `${who} kirjataan ulos eikä voi kirjautua. ${c} ${n(c, 'luokkatehtävä poistetaan', 'luokkatehtävää poistetaan')}. Hänen kyselyidensä tulokset säilyvät luokan ja koulun historiassa.`,
  'pa.deactivateOther': 'Henkilö työskentelee myös toisessa koulussa, joten vain hänen roolinsa tässä koulussa päättyvät; tili pysyy käytössä siellä.',
  'pa.dr_left_school': 'Lähti koulusta',
  'pa.dr_leave': 'Vapaalla',
  'pa.dr_role_ended': 'Tehtävä päättyi',
  'pa.dr_other': 'Muu',
  'pa.reactivateOn': 'Aktivoi automaattisesti',
  'pa.deactivated': 'Poistettu käytöstä.',
  'pa.soleTeacher': (classes: string) => `Poistettu käytöstä. Näillä luokilla ei nyt ole opettajaa: ${classes}.`,
  'pa.reassignNow': 'Liitä uusi opettaja nyt',
  'pa.reactivate': 'Aktivoi uudelleen',
  'pa.restoreAssignments': 'Palauta myös viimeisimmät luokkatehtävät',
  'pa.erase': 'Poista henkilötiedot',
  'pa.eraseTitle': (who: string) => `Poistetaanko henkilön ${who} henkilötiedot?`,
  'pa.eraseIntro': 'Kirjautuminen, nimi ja sähköposti poistetaan; lokeissa näkyy ”Entinen henkilökunnan jäsen #NNNN”. Kyselymäärät ja koosteet säilyvät. Kuitti tallennetaan arkistoon. Tätä ei voi perua.',
  'pa.eraseSecondAdmin': 'Henkilö on koulun ylläpitäjä tai ensisijainen rehtori: toisen alustan ylläpitäjän on hyväksyttävä poisto koulun kirjallisesta ohjeesta.',
  'pa.eraseAfterDeactivate': 'Oikea henkilökunta poistetaan ensin käytöstä; sen jälkeen tietojen poisto on mahdollista.',
  'pa.er_own_request': 'Henkilön oma pyyntö',
  'pa.er_left_school': 'Lähti koulusta',
  'pa.er_test_cleanup': 'Testien siivous',
  'pa.er_other': 'Muu',
  'pa.instruction': 'Koulun kirjallinen ohje (kuka, milloin)',
  'pa.typeEmail': (e: string) => `Kirjoita ${e} vahvistaaksesi`,
  'pa.erasedDone': 'Henkilötiedot poistettu. Kuitti on arkistossa.',
  'pa.eraseRequested': 'Poistoa pyydetty. Se tehdään, kun toinen alustan ylläpitäjä hyväksyy sen Hyväksynnöissä.',
  'pa.addRole': '+ Lisää rooli',
  'pa.before': 'Nyt:',
  'pa.after': 'Jälkeen:',
  'pa.reachHead': 'koulun, vuosiluokkien ja luokkien tulokset',
  'pa.reachAdmin': 'henkilökunta, luokat ja asetukset — ei tuloksia',
  'pa.reachCounsellorAll': 'kaikkien vuosiluokkien tulokset, koko koulu',
  'pa.reachCounsellorGrades': (g: string) => `vuosiluokkien ${g} tulokset`,
  'pa.reachTeacher': (c: string) => `luokkien ${c} tulokset`,
  'pa.reachTeacherNone': 'ei vielä luokkia',
  'pa.roleAddedNow': 'Rooli lisätty. Se on voimassa henkilön seuraavasta toimesta alkaen.',
  'pa.roleToHead': 'Pyyntö lähetetty ensisijaiselle rehtorille hyväksyttäväksi.',
  'pa.roleToZencera': 'Koululla ei ole ensisijaista rehtoria, joten pyyntö on Zenceran Hyväksynnöissä. Varmista asia koulun allekirjoittajalta ennen hyväksymistä.',
  'pa.removeRoleTitle': (r: string) => `Poistetaanko rooli ${r}?`,
  'pa.removeRoleIntro': 'Henkilö menettää heti sen, mitä tämä rooli näkee. Opettaja-roolin poisto päättää myös luokkatehtävät.',
  'pa.removeRoleFor': (r: string) => `Poista rooli ${r}`,
  'pa.makePrimaryAction': 'Tee ensisijaiseksi rehtoriksi',
  'pa.makePrimaryIntro': 'Siirtää ensisijaisuuden nykyiseltä rehtorilta. Tee tämä vain koulun allekirjoittajan kanssa vahvistettuasi; siirto tallennetaan arkistoon.',
  'pa.confirmedWith': 'Vahvistettu (kenen kanssa, miten, milloin)',
  'pa.confirmedWithHint': (s: string) => `Koulun kirjattu allekirjoittaja: ${s}.`,
  'pa.editDetails': 'Muokkaa tietoja',
  'pa.emailChangeLater': 'Sähköpostin muutos vahvistetaan uudesta osoitteesta, kun sähköpostikirjautuminen on käytössä.',
  'pa.assignments': 'Luokat ja vuosiluokat',
  'pa.assign': 'Liitä',
  'pa.assignTitle': (who: string) => `Liitä ${who}`,
  'pa.grade': 'Vuosiluokka',
  'pa.noClassesWho': 'Ei vielä luokkia. Hänen näkymänsä kertoo, keneltä kysyä.',
  'pa.notATeacher': 'Vain Opettaja-roolin henkilöitä liitetään luokkiin.',
  'pa.unassign': 'Irrota',
  'pa.unassignFrom': (c: string) => `Irrotetaanko luokasta ${c}?`,
  'pa.unassignIntro': 'Pääsy luokan tuloksiin päättyy heti. Avoin kysely jatkuu loppuun, ja sen vastaukset lasketaan.',
  'pa.unassignedOpen': 'Irrotettu. Luokassa on avoin kysely; se jatkuu loppuun asti.',
  'pa.secondHomeroom': (c: string) => `Liitetty. Huom: luokalla ${c} on nyt kaksi ryhmänohjaajaa.`,
  'pa.activity': 'Toiminta',

  'pa.namingConvention': 'Nimeämistapa',
  'pa.editLists': 'Muokkaa vuosiluokkia ja rinnakkaisluokkia',
  'pa.levelsNow': (l: string) => `Vuosiluokat: ${l}`,
  'pa.sectionsNow': (s: string) => `Rinnakkaisluokat: ${s}`,
  'pa.listsIntro': 'Luokkien nimet muodostetaan näistä listoista (vuosiluokka 7 + A = 7A), niitä ei kirjoiteta käsin.',
  'pa.levelsInUseHint': 'Vuosiluokkaa, jolla on luokkia, ei voi poistaa.',
  'pa.sectionScheme': 'Rinnakkaisluokkien merkintä',
  'pa.scheme_letters': 'Kirjaimet A–F',
  'pa.scheme_numbers': 'Numerot 1–6',
  'pa.scheme_custom': 'Oma lista',
  'pa.sections': 'Rinnakkaisluokat',
  'pa.removeSection': (s: string) => `Poista rinnakkaisluokka ${s}`,
  'pa.inUse': '(käytössä — se poistetaan käytöstä, ei poisteta)',
  'pa.addSection': 'Lisää rinnakkaisluokka',
  'pa.sectionsInUseHint': 'Käytössä oleva rinnakkaisluokka poistetaan käytöstä, sitä ei poisteta.',
  'pa.addClasses': 'Lisää luokkia',
  'pa.addClassesHint': 'Valitse luotavat luokat. Olemassa olevat luokat on valittu ja lukittu.',
  'pa.needLists': 'Aseta ensin vuosiluokat ja rinnakkaisluokat.',
  'pa.gridCaption': 'Vuosiluokat ja rinnakkaisluokat; valitse ruutu luodaksesi luokan',
  'pa.classExistsLabel': (c: string) => `${c} on jo olemassa`,
  'pa.createClassLabel': (c: string) => `Luo ${c}`,
  'pa.expectedSize': 'Oppilasmäärä',
  'pa.expectedSizeHint': 'Pakollinen. Oppilaiden määrä — ei koskaan nimiä. Osallistumisaste lasketaan sen avulla.',
  'pa.smallClassWarn': 'Alle 5: luokan tulokset piilotetaan yleensä ja lasketaan koulun kokonaismäärään.',
  'pa.createNClasses': (c: number) => `Luo ${c} ${n(c, 'luokka', 'luokkaa')}`,
  'pa.classesCreated': (c: number) => `${c} ${n(c, 'luokka', 'luokkaa')} luotu.`,
  'pa.classesThisYear': (y: string) => `Luokat ${y}`,
  'pa.noClassesSchool': 'Ei vielä luokkia.',
  'pa.noGrade': 'Ei vuosiluokkaa (vanhemmat luokat)',
  'pa.noClassesInGrade': 'Vuosiluokalla ei vielä ole luokkia.',
  'pa.leadChip': (who: string) => `Vastuuopettaja: ${who}`,
  'pa.addGradeLead': '+ Vastuuopettaja',
  'pa.addGradeLeadTo': (g: string) => `Lisää vastuuopettaja: ${g}`,
  'pa.removeAssignment': (who: string, c: string) => `Irrota ${who} luokasta ${c}`,
  'pa.sizeN': (c: number) => `${c} oppilasta`,
  'pa.sizeUnknown': 'Määrä puuttuu',
  'pa.noTeacher': 'Ei opettajaa',
  'pa.assignShort': 'Liitä',
  'pa.assignTo': (c: string) => `Liitä opettaja luokkaan ${c}`,
  'pa.size': 'Koko',
  'pa.editSizeOf': (c: string) => `Luokan ${c} oppilasmäärä`,
  'pa.archive': 'Arkistoi',
  'pa.archiveOf': (c: string) => `Arkistoi tai poista ${c}`,
  'pa.archiveTitle': (c: string) => `Arkistoidaanko ${c}?`,
  'pa.archiveClassIntro': 'Luokka poistuu opettajien valinnoista ja tehtävät päättyvät; historia säilyy. Voit palauttaa sen.',
  'pa.delete': 'Poista',
  'pa.deleteTitle': (c: string) => `Poistetaanko ${c}?`,
  'pa.deleteIntro': 'Luokalla ei ole koskaan ollut kyselyä, joten sen voi poistaa kokonaan.',
  'pa.archivedDone': 'Luokka arkistoitu.',
  'pa.deletedDone': 'Luokka poistettu.',
  'pa.archivedN': (c: number) => `Arkistoidut luokat (${c})`,
  'pa.restore': 'Palauta',
  'pa.restoreOf': (c: string) => `Palauta ${c}`,
  'pa.restored': 'Luokka palautettu.',
  'pa.noTeachersYet': 'Kenelläkään ei vielä ole Opettaja-roolia. Lisää ensin henkilö, jolla on se.',
  'pa.searchStaff': 'Hae henkilökunnasta',
  'pa.teacher': 'Opettaja',
  'pa.secondHomeroomWarn': 'Luokalla on jo ryhmänohjaaja. Toinen on sallittu (jaettu tehtävä).',

  'pa.profile': 'Koulun tiedot',
  'pa.codeNeverChanges': 'ei muutu koskaan',
  'pa.levelsOnClasses': 'Vuosiluokat ja rinnakkaisluokat ovat Luokat-välilehdellä.',
  'pa.safetyNetHint': 'Näytetään oppilaille jokaisessa kyselynäkymässä heidän kielellään. Kerro, kenelle voi puhua ja missä, sekä auttava puhelin.',
  'pa.messageIn': (l: string) => `Viesti: ${l}`,
  'pa.useTemplate': 'Käytä mallia',
  'pa.safetyTemplate_fi': 'Jos sinulla on huolia, voit puhua kuraattorin kanssa: [nimi], huone [numero]. Voit soittaa myös Sekasin-chattiin tai numeroon 116 111 (Lasten ja nuorten puhelin).',
  'pa.safetyTemplate_sv': 'Om något oroar dig kan du prata med kuratorn: [namn], rum [nummer]. Du kan också ringa 116 111 (Barnens och ungas telefon).',
  'pa.safetyTemplate_en': 'If something is worrying you, you can talk to the school counsellor: [name], room [number]. You can also call 116 111 (helpline for children and young people).',
  'pa.previewIn': 'Esikatselu',
  'pa.previewLabel': 'Oppilasnäkymän esikatselu',
  'pa.previewEmpty': 'Ei vielä viestiä.',
  'pa.policies': 'Käytännöt',
  'pa.polSelfService': 'Opettajat voivat liittää itsensä luokkiin',
  'pa.polSelfServiceDesc': 'Koulun olemassa olevista luokista; koulun ylläpitäjä saa tiedon ja voi perua sen. Oletus: pois.',
  'pa.polWholeSchool': 'Kuraattorit näkevät koko koulun',
  'pa.polWholeSchoolDesc': 'Pois: kuraattorit näkevät vain heille määrätyt vuosiluokat. Oletus: päällä.',
  'pa.confirmations': 'Käyttöönoton vahvistukset',
  'pa.confirmationsHint': 'Vaiheet, jotka tehdään Swipen ulkopuolella. Jokainen kirjataan tekijän ja ajan kanssa.',

  'pa.approvalsIntro': 'Pyynnöt, joista vain Zencera päättää: pääsyä laajentavat roolit koulussa, jolla ei ole päärehtoria eikä hyväksyntöjen sijaista; sekä — toisen alustan ylläpitäjän päättäminä — päärehtorin tai koulun ylläpitäjän tietojen poisto ja päärehtorin nimitys koulun pyynnöstä.',
  'pa.waiting': 'Odottaa',
  'pa.noApprovals': 'Pyyntöjä ei odota.',
  'pa.apWiden': (who: string, r: string) => `${who} — lisää ${r}`,
  'pa.apErase': (who: string) => `${who} — poista henkilötiedot`,
  'pa.apWidenWhy': 'Koululla ei ole aktiivista ensisijaista rehtoria. Varmista asia koulun allekirjoittajalta sovelluksen ulkopuolella ennen hyväksymistä.',
  'pa.apInstruction': (s: string) => `Koulun ohje: ${s}`,
  'pa.apWaitingSecond': 'Sinä pyysit tätä. Se odottaa toista alustan ylläpitäjää.',
  'pa.requestedBy': (who: string, d: string) => `pyytänyt ${who}, ${d}`,
  'pa.expiresOn': (d: string) => `vanhenee ${d}`,
  'pa.approve': 'Hyväksy',
  'pa.approveErase': 'Hyväksy ja poista',
  'pa.reject': 'Hylkää',
  'pa.approveTitle': 'Hyväksytäänkö pyyntö?',
  'pa.rejectTitle': 'Hylätäänkö pyyntö?',
  'pa.approved': 'Hyväksytty.',
  'pa.rejected': 'Hylätty.',

  'pa.logIntro': 'Vain lisättävä ja muutokset paljastava: jokaisessa rivissä on edellisen rivin tiiviste. Näyttää, kuka teki mitä ja milloin — ei koskaan sitä, mitä joku näki tuloksissa.',
  'pa.logScope': 'Mikä loki',
  'pa.logPlatform': 'Alustan tapahtumat',
  'pa.logAll': 'Kaikki koulut ja alusta',
  'pa.logSchool': (s: string) => `Toiminta — ${s}`,
  'pa.filterAction': 'Suodata toimen mukaan',
  'pa.allActions': 'Kaikki toimet',
  'pa.from': 'Alkaen',
  'pa.to': 'Asti',
  'pa.exportCsv': 'Vie CSV',
  'pa.verifyChain': 'Tarkista tiivisteketju',
  'pa.chainOk': (c: number) => `Ketju ehjä (${c} riviä tarkistettu)`,
  'pa.chainBroken': (id: number) => `Ketju katkeaa rivillä ${id}`,
  'pa.logEmpty': 'Näillä suodattimilla ei ole kirjauksia.',
  'pa.logMoreLoaded': (c: number) => `${c} riviä lisää ladattu.`,
  'pa.colTime': 'Aika',
  'pa.colWho': 'Kuka',
  'pa.colRole': 'Roolissa',
  'pa.colAction': 'Toimi',
  'pa.colTarget': 'Kohde',
  'pa.colDetails': 'Tiedot',
  'pa.archiveIntro': 'Täydet kopiot liiketoiminnan ja sääntelyn kannalta kriittisistä tietueista. Niitä ei koskaan karsita eikä muokata.',
  'pa.records': 'Tietueet',
  'pa.filterKind': 'Suodata lajin mukaan',
  'pa.filterSchool': 'Suodata koulun mukaan',
  'pa.allKinds': 'Kaikki lajit',
  'pa.noRecords': 'Näillä suodattimilla ei ole tietueita.',
  'pa.ak_school_created': 'Koulu luotu',
  'pa.ak_school_type_changed': 'Koulun tyyppi muuttui',
  'pa.ak_school_state_changed': 'Koulun tila muuttui',
  'pa.ak_paperwork_changed': 'Sopimus muuttui',
  'pa.ak_access_widened': 'Pääsy laajeni',
  'pa.ak_primary_head_changed': 'Ensisijainen rehtori vaihtui',
  'pa.ak_erasure_receipt': 'Poistokuitti',
  'pa.ak_suspension_notice': 'Keskeytysilmoitus',
  'pa.ak_offboarding_acknowledged': 'Poisto vahvistettu',
  'pa.ak_offboarding_report': 'GDPR-yhteenveto',

  'pa.notifEmail': 'Alustan ilmoitussähköposti',
  'pa.notifEmailOn': 'Zenceraa vaativat tapahtumat lähetetään tähän sekä näytetään ilmoituskeskuksessa.',
  'pa.notifEmailOff': 'Sähköpostipalvelua ei ole vielä käytössä, joten tapahtumat näkyvät vain ilmoituskeskuksessa. Nyt tallennettua osoitetta käytetään, kun sähköposti on käytössä.',
  'pa.mfaEnforce': 'Kaksivaiheinen tunnistautuminen alustan ylläpitäjille',
  'pa.mfaOnBody': 'Jokainen alustan ylläpitäjän toimi vaatii todennuskoodilla tehdyn kirjautumisen.',
  'pa.mfaOffBody': 'Ei vielä vaadittu. Ennen käyttöönottoa:',
  'pa.mfaReqTwo': (c: number) => `Vähintään kaksi alustan ylläpitäjää (nyt ${c})`,
  'pa.mfaReqAll': 'Jokaisella alustan ylläpitäjällä on todennussovellus',
  'pa.mfaReqSession': 'Tässä kirjautumisessa käytettiin todennuskoodiasi.',
  'pa.mfaVerifyNow': 'Vahvista nyt',
  'pa.mfaTurnOn': 'Ota vaatimus käyttöön',
  'pa.mfaTurnOff': 'Poista vaatimus käytöstä',
  'pa.platformAdmins': 'Alustan ylläpitäjät',
  'pa.platformAdminsHint': 'Zenceran työntekijät, joilla on alustan ylläpitäjän rooli. Uudet lisätään erikseen (README §6). Jokaisella pitäisi olla kaksi todennussovellusta: pää- ja varasovellus.',
  'pa.health': 'Tietokannan tila',
  'pa.dbSize': 'Tietokannan koko',
  'pa.freeSpace': 'Vapaa tila',
  'pa.actionNeeded': 'Toimia tarvitaan',
  'pa.logSize': 'Lokin koko',
  'pa.archiveRows': 'Arkiston tietueet',
  'pa.healthHint': 'Vain koot — ei koulu- tai käyttäjätietoja. Viikoittainen tarkistus hälyttää, kun vapaata on alle 0,2 Gt.',
  'pa.maintenance': 'Ylläpito',
  'pa.sweepHint': 'Vanhentuneet testitilit poistetaan automaattisesti joka yö. Voit ajaa poiston nyt.',
  'pa.sweepNow': 'Poista vanhentuneet testitilit nyt',
  'pa.sweepIntro': 'Poistaa jokaisen vanhentuneen testitilin ja tekee jokaisesta kuitin. Tätä ei voi perua.',
  'pa.sweepGo': 'Poista ne',
  'pa.sweepDone': (c: number) => `${c} ${n(c, 'vanhentunut testitili', 'vanhentunutta testitiliä')} poistettu.`,
  'pa.rosterHint': 'Lisää henkilöitä koulun Henkilökunta-välilehdeltä: testitilit hiekkalaatikkokouluihin, kutsut asiakaskouluihin.',

  'lvl.vl1': '1', 'lvl.vl2': '2', 'lvl.vl3': '3', 'lvl.vl4': '4', 'lvl.vl5': '5', 'lvl.vl6': '6',
  'lvl.vl7': '7', 'lvl.vl8': '8', 'lvl.vl9': '9',
  'lvl.lukio1': 'Lukio 1', 'lvl.lukio2': 'Lukio 2', 'lvl.lukio3': 'Lukio 3',
  'lvl.amm': 'Ammatillinen',

  'notif.title': 'Ilmoitukset',
  'notif.bell': 'Ilmoitukset',
  'notif.bellUnread': (c: number) => `Ilmoitukset, ${c} lukematonta`,
  'notif.home': 'Etusivu',
  'notif.unreadN': (c: number) => `${c} lukematonta`,
  'notif.allCaughtUp': 'Kaikki luettu',
  'notif.markAll': 'Merkitse kaikki luetuiksi',
  'notif.allRead': 'Kaikki merkitty luetuiksi.',
  'notif.empty': 'Ei vielä mitään. Sinuun vaikuttavat muutokset näkyvät täällä.',
  'notif.new': 'Uusi',
  'notif.roleAdded': (r: string) => `Sinulle on annettu rooli ${r}.`,
  'notif.roleRemoved': (r: string) => `Roolisi ${r} poistettiin.`,
  'notif.approvalWaiting': (r: string) => `Pyyntö lisätä rooli ${r} odottaa hyväksyntääsi.`,
  'notif.approvalNoHead': (r: string) => `Koulu ilman ensisijaista rehtoria tarvitsee Zenceran päätöksen pyynnöstä lisätä ${r}.`,
  'notif.approvalApproved': 'Pyyntösi hyväksyttiin.',
  'notif.approvalRejected': 'Pyyntösi hylättiin.',
  'notif.eraseSecond': 'Tietojen poisto tarvitsee toisen alustan ylläpitäjän hyväksynnän.',
  'notif.assigned': (c: number) => `Sinut on lisätty ${c} ${n(c, 'luokkaan', 'luokkaan')}.`,
  'notif.unassigned': 'Sinut irrotettiin luokasta.',
  'notif.primaryHead': 'Olet nyt ensisijainen rehtori.',
  'notif.paperwork': (s: string) => `Sopimuksen tila muuttui: ${s}.`,
  'notif.schoolLive': 'Käyttöönotto on valmis: kyselyt voivat avautua.',
  'notif.dedicatedRequested': 'Taso B: perusta koululle oma tietokanta ja vahvista se koulun sivulla.',
  'notif.dedicatedCancelled': 'Taso B peruttu: koulu ei enää tarvitse omaa tietokantaa.',
  'notif.dedicatedPending': 'Zencera perustaa koulullesi oman tietokannan. Saat tiedon, kun se on valmis.',
  'notif.dedicatedReady': 'Koulusi oma tietokanta on valmis.',
  'notif.reactivated': 'Henkilökunnan jäsen aktivoitiin automaattisesti.',

  'pa.soTitle': 'Koulun sisällä — vain tukitilassa',
  'pa.soBody': (what: string) => `${what} kuuluvat koululle. Zencera näkee ja muuttaa niitä vain tukitilassa: syyn kanssa, kahden tunnin ajan, kirjattuna koulun omaan toimintalokiin ja alustan lokiin.`,
  'pa.soHint': 'Koulun yhteenveto, tarkistuslista, elinkaari ja toiminta ovat käytettävissä ilman sitä.',
  'pa.soStaff': 'Henkilökunnan nimet, sähköpostit, roolit ja kirjautumiset',
  'pa.soClasses': 'Luokat ja opettajien tehtävät',
  'pa.soSettings': 'Koulun tiedot, käytännöt ja turvaverkkoviesti',
  'pa.soPerson': 'Tämän henkilön tiedot, roolit ja tili',
  'pa.soOffboardedTitle': 'Koulu on lähtenyt Swipestä',
  'pa.soOffboardedBody': 'Henkilökunnan tiedot poistettiin koulun poiston yhteydessä. GDPR-yhteenveto on arkistossa.',
  'pa.apNeedsSupport': 'Päätös avaa ensin koulun tukitilan (kirjataan sen toimintalokiin).',
  'head.approvals': (c: number) => `Odottavat hyväksynnät (${c})`,
  'head.approvalsHint': 'Roolit, jotka laajentavat sitä, mitä joku näkee, odottavat sinua ensisijaisena rehtorina. Pyynnöt vanhenevat 14 päivässä.',
  'teacher.notReady': 'Koulusi käyttöönotto ei ole valmis, joten kyselyjä ei voi vielä avata. Kysy koulusi ylläpitäjältä.',
  'teacher.startFailed': 'Kyselyä ei voitu avata. Yritä uudelleen.',

  'err.password_not_changed': 'Uutta salasanaasi ei ole vielä tallennettu. Valitse uusi salasana ja yritä uudelleen.',
  'err.password_change_required': 'Valitse ensin oma salasana.',
  'pa.pendingRolesNote': (roles: string) =>
    `Odottaa ensisijaisen rehtorin hyväksyntää: ${roles}. Tili voi käyttää näitä rooleja, kun ne on hyväksytty.`,
  'pw.title': 'Valitse oma salasana',
  'pw.intro': (name: string) =>
    `Tervetuloa, ${name}. Saamallasi salasanalla voi kirjautua vain kerran. Valitse uusi salasana, jonka vain sinä tiedät — mikään ei avaudu ennen sitä.`,
  'pw.new': 'Uusi salasana',
  'pw.again': 'Uusi salasana uudelleen',
  'pw.hint': (min: number) => `Vähintään ${min} merkkiä. Muutama toisiinsa liittymätön sana on hyvä salasana.`,
  'pw.tooShort': (min: number) => `Käytä vähintään ${min} merkkiä.`,
  'pw.mismatch': 'Salasanat eroavat. Kirjoita sama salasana molempiin kenttiin.',
  'pw.sameAsBefore': 'Tämä on saamasi salasana. Valitse eri salasana.',
  'pw.weak': 'Salasana on liian helppo arvata. Valitse pidempi tai harvinaisempi.',
  'pw.save': 'Tallenna salasana',
  'pw.saving': 'Tallennetaan…',
  'pw.retry': 'Yritä uudelleen',
  'pw.failed': 'Salasanaa ei voitu tallentaa. Tarkista yhteys ja yritä uudelleen.',
  'pw.savedRetry': 'Uusi salasanasi on tallennettu, mutta Swipe ei vielä voinut vahvistaa sitä. Yritä uudelleen — sitä ei tarvitse kirjoittaa uudestaan.',
};
